﻿﻿export interface IMatchingSurgery {
    swapNumber: string;
    donorId: number;
    donorAlias: string;
    donorCenter: string;
    pickupDate: string;
    recipientId: number;
    recipientAlias: string;
    recipientCenter: string;
}
